import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const planExpiryInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        if (body?.planexpaire === true) {
          router.navigate(['/subscriptions/plans']);
        }
      }
    })
  );
};